import { useFormContext } from '../context/FormContext';

/**
 * useReadOnly
 *
 * Returns helpers for components to behave correctly in read-only mode.
 * When isReadOnly is true:
 *  - All form inputs should be disabled
 *  - API calls (createQuote, updateQuote, processPayment, issuePolicy) are skipped
 *  - Navigation just routes to the next/prev step without saving anything
 *
 * Usage in any signup step:
 *   const { isReadOnly, readOnlyProps } = useReadOnly();
 *
 *   // In handleContinue:
 *   if (isReadOnly) { history.push('/signup/confirm-details'); return; }
 */
export function useReadOnly() {
    const { formData } = useFormContext();
    const isReadOnly = !!formData.isReadOnly;

    return {
        isReadOnly,

        /**
         * readOnlyProps
         * Spread onto any input/select/textarea to disable it in read-only mode.
         * Also adds a subtle visual style.
         *
         * Usage: <input {...readOnlyProps} ... />
         */
        readOnlyProps: isReadOnly
            ? { disabled: true, style: { opacity: 0.7, cursor: 'not-allowed' } }
            : {},
    };
}